import type { GameCommunicationMetaType, GameCommunicationSenderType } from '../../../services/gameCommunication/types';
import type { CoreStoreType } from '../../../store/CoreStore';
import type { GameCommunicationMessageType } from '../types';

export abstract class BaseCoreGameCommunicationProcessor {
  public abstract messageName: string;
  public delay?: number;
  /* A number value that represents the delay in milliseconds before the processor runs. */
  public delayCorrection?: number;
  /* A number value that used to clear message from process queue after process or timeout.  */
  public seq?: number;

  public constructor(protected store: CoreStoreType) {}

  /* A number value that represents the correction to be applied to the delay before the processor runs. */
  public abstract process(
    message: GameCommunicationMessageType,
    _store: CoreStoreType, // Due to compatibility reasons, the store parameter is not used in the method.
    sender: GameCommunicationSenderType,
    meta?: GameCommunicationMetaType
  ): void;
}
